import { useEventingContext } from '@/context/eventing';
import { ConfigurableProduct } from '@/types/graphql.prod';

export const useGTM = ({ item }: { item: ConfigurableProduct }) => {
  const finalPrice = item?.price_range?.maximum_price?.final_price?.value;

  const discountAmount = item?.price_range?.maximum_price?.discount?.amount_off;

  const currencyCode = item?.price_range?.maximum_price?.final_price?.currency;

  const [, { dispatch }] = useEventingContext();

  const handleLinkClick = () => {
    dispatch({
      type: 'PRODUCT_CLICK',
      payload: {
        name: item.name,
        sku: item.sku,
        priceTotal: finalPrice,
        discountAmount,
        currencyCode,
        selectedOptions: null,
      },
    });

    if (item) {
      try {
        (window as any).dataLayer &&
          (window as any).dataLayer.push({
            ecommerce: null,
          });
        const dl = (window as any).dataLayer || [];
        const viewItemListEvent = [...dl].reverse().find((event: any) => event.event === 'view_item_list');

        let fallbackName =
          (item as any)?.categories?.[0]?.name || (item as any)?.categories?.[0]?.breadcrumbs?.[0]?.category_name || '';
        if (!fallbackName) {
          if (window.location.pathname.includes('search')) {
            fallbackName = 'Search Results';
          } else {
            fallbackName = document.title.split('-')[0].trim();
          }
        }

        const categoryName = viewItemListEvent?.ecommerce?.item_list_name || fallbackName;

        const ga4Payload = {
          event: 'select_item',
          ecommerce: {
            item_list_name: categoryName,
            item_list_id: categoryName,
            items: [
              {
                item_name: item.name,
                item_id: item.sku,
                price:
                  item?.price_range?.minimum_price?.final_price?.value ||
                  item?.price_range?.maximum_price?.final_price?.value,
                quantity: 1,
                item_category: categoryName,
              },
            ],
          },
        };
        console.log('👉 [GA4 Event] select_item triggered', ga4Payload);
        (window as any).dataLayer && (window as any).dataLayer.push(ga4Payload);
      } catch (err) {
        console.error(err);
      }
    }
  };

  return {
    handleLinkClick,
  };
};
